import { getAssetClassLabel } from '../utils';
import { getFileName, logAssetDownload } from '../../ItemDataCategoryTable/ItemDataCategoryTableUtils';
import filesize from 'filesize';
import { getAssetURL } from '../../../../api';
import React from 'react';
import { getExternalLinkIcon, getFileExtension, isUrlAsset, truncateFileName } from '../../../../helpers';

const ArticleAssetRow = ({ asset, idx, locale = 'it_IT', showDescription = false, articleDetails = null }) => {
    // Determina se l'asset è un URL esterno (non un file con URL)
    // Usa asset.extension per determinare se è un file (pdf, jpg, etc.) o un URL (null o 'url')
    const isExternalUrl = (isUrlAsset(asset.public_url) && !asset.extension) || asset.extension === 'url'
    const ExternalLinkIcon = getExternalLinkIcon()

    return (
        <tr className={`table-asset-row ${idx % 2 === 0 ? 'even' : 'odd'}`}>
            <td className="px-3 py-2 whitespace-nowrap text-xs">
                { getAssetClassLabel(asset.asset_classes_type[0], asset.asset_classes, locale) }
            </td>
            {showDescription && (
                <td className="px-3 py-2 whitespace-nowrap text-xs">
                    {asset.description || '-'}
                </td>
            )}
            <td className="px-3 py-2 whitespace-nowrap text-xs">
                { truncateFileName(getFileName(asset.url), 50) }
            </td>
            <td className="px-3 py-2 whitespace-nowrap text-xs">
                {
                    asset.size > 0 ? filesize(asset.size, {
                        separator: ',',
                        base: 10,
                    }) : '-'
                }
            </td>
            <td className="px-3 py-2 whitespace-nowrap text-xs text-right">
                {isExternalUrl ? (
                    <a
                        className="btn btn-primary"
                        title="Apri link"
                        href={asset.public_url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <ExternalLinkIcon />
                    </a>
                ) : (
                    <a
                        className="btn btn-primary"
                        title="Download"
                        href={getAssetURL(encodeURIComponent(asset.url))}
                        onClick={() => logAssetDownload(articleDetails, asset)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="icon icon-download" />
                    </a>
                )}
            </td>
        </tr>
    )
}

export default ArticleAssetRow